/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DelegationStatusCount,
  DelegationStatusCount$inboundSchema,
} from "./delegationstatuscount.js";

/**
 * unknown means no current observations; observed means matching observations exist; configuration_failure means the current delegation configuration is known to be invalid, not a per-human observation.
 */
export const OrganizationClientDelegationStatusStatus = {
  Unknown: "unknown",
  Observed: "observed",
  ConfigurationFailure: "configuration_failure",
} as const;
/**
 * unknown means no current observations; observed means matching observations exist; configuration_failure means the current delegation configuration is known to be invalid, not a per-human observation.
 */
export type OrganizationClientDelegationStatusStatus = OpenEnum<
  typeof OrganizationClientDelegationStatusStatus
>;

/**
 * Latest per-human observations for the current client configuration within 30 days. Unknown when no matching observations exist. A known invalid delegation configuration, including a missing active signing key, reports configuration_failure with no observations. Credential presence does not guarantee future renewal.
 */
export type OrganizationClientDelegationStatus = {
  observations: Array<DelegationStatusCount>;
  /**
   * unknown means no current observations; observed means matching observations exist; configuration_failure means the current delegation configuration is known to be invalid, not a per-human observation.
   */
  status: OrganizationClientDelegationStatusStatus;
  /**
   * Inclusive observation window start.
   */
  windowStart: Date;
};

/** @internal */
export const OrganizationClientDelegationStatusStatus$inboundSchema:
  z.ZodMiniType<OrganizationClientDelegationStatusStatus, unknown> = openEnums
    .inboundSchema(OrganizationClientDelegationStatusStatus);

/** @internal */
export const OrganizationClientDelegationStatus$inboundSchema: z.ZodMiniType<
  OrganizationClientDelegationStatus,
  unknown
> = z.pipe(
  z.object({
    observations: z.array(DelegationStatusCount$inboundSchema),
    status: OrganizationClientDelegationStatusStatus$inboundSchema,
    window_start: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "window_start": "windowStart",
    });
  }),
);

export function organizationClientDelegationStatusFromJSON(
  jsonString: string,
): SafeParseResult<OrganizationClientDelegationStatus, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      OrganizationClientDelegationStatus$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OrganizationClientDelegationStatus' from JSON`,
  );
}
